import { render, staticRenderFns } from "./ListStudents.vue?vue&type=template&id=1e66d983"
import script from "./ListStudents.vue?vue&type=script&lang=js"
export * from "./ListStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports